/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import ModelEditContext from "components/model-selector/context";
import AddModelButton from "components/model-selector/add-model-button/index";
import ModelSelectDialog from "components/model-selector/dialog/index";
import ModelSelectorDisplay from "components/model-selector/display/index";
import ModelDeleteDialog from "components/model-selector/dialog-delete";

const ModelSelector = (props) => {
    const AddComponent = props.AddComponent;
    const DisplayComponent = props.DisplayComponent;
    const filter = props.filter;
    const filterValue = props.filterValue;

    // External callbacks
    const model = props.model;
    const onSelectModelHandler = props.onSelectModel;
    const onModelRemoved = props.onModelRemoved;

    // Internal state
    const [models, setModels] = useState(); // for Gallery
    const [original, setOriginal] = useState(); // for Gallery
    const [selectedModel, setSelectedModel] = useState(model);
    const [open, setOpen] = useState(false);
    const [openRemove, setOpenRemove] = useState(false);
    const [hasModel, setHasModel] = useState();
    const [localState, setLocalState] = useState({
        model: { title: "", description: "" },
    });

    const onChange = async () => {
        setOpen(true);
    };
    const onRemove = async () => {
        setOpenRemove(true);
    };
    const onSelectModel = (selectModel) => {
        setSelectedModel(selectModel);
        onSelectModelHandler(selectModel);
        handleClose();
    };
    const handleClose = () => {
        setSelectedModel(original);
        setOpen(false);
    };
    const ctx = {
        open,
        setOpen,
        handleClose,
        model,
        hasModel,
        onChange,
        onRemove,
        selectedModel,
        setSelectedModel,
        openRemove,
        setOpenRemove,
        onSelectModel,
        onModelRemoved,
        models,
        setModels,
        localState,
        setLocalState,
    };

    useEffect(() => {
        if (model) {
            setOriginal(model);
            setSelectedModel(model);
            setHasModel(true);
        }
    }, [model]);

    useEffect(() => {
        if (selectedModel) {
            setHasModel(true);
        }
    }, [selectedModel]);

    return (
        <Fragment>
            <ModelEditContext.Provider value={ctx}>
                <ModelSelectorDisplay AddComponent={AddComponent} DisplayComponent={DisplayComponent} />
                <ModelSelectDialog filter={filter} filterValue={filterValue} />
                <ModelDeleteDialog deleteType='REMOVE' />
            </ModelEditContext.Provider>
        </Fragment>
    );
};

export { ModelSelectorDisplay, AddModelButton, ModelSelectDialog };
export default ModelSelector;
